import { ref } from "vue";

import type { DevLink } from "@/backend/read/devLinks";
import { fetchDevLinks } from "@/backend/read/devLinks";
import { SimpleCache } from "@/utils/SimpleCache";

const cache = new SimpleCache<DevLink[]>({ timeout: 30_000 });

export function useDevLinks(issueKey: string | undefined) {
  const devLinks = ref<DevLink[]>([]);
  const loaded = ref(false);

  async function load() {
    if (!issueKey) return;
    try {
      devLinks.value = await cache.loadItem(issueKey, () => fetchDevLinks(issueKey));
    } catch {
      devLinks.value = [];
    } finally {
      loaded.value = true;
    }
  }

  return { devLinks, loaded, load };
}
